import { render, staticRenderFns } from "./ReportConsolidatedMarking.vue?vue&type=template&id=24c31b89&scoped=true"
import script from "./ReportConsolidatedMarking.vue?vue&type=script&lang=js"
export * from "./ReportConsolidatedMarking.vue?vue&type=script&lang=js"
import style0 from "./ReportConsolidatedMarking.vue?vue&type=style&index=0&id=24c31b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c31b89",
  null
  
)

export default component.exports